<div class="space-y-8">

  @if (section) {

    <!-- ══════════════════════════════════════════════════════════════════════ -->
    <!-- 1. BANNER CONFIGURATOR                                                 -->
    <!-- ══════════════════════════════════════════════════════════════════════ -->
    @if (section.type === 'banner') {
      <div class="space-y-4">
        <div class="flex items-center justify-between">
          <span class="text-[10px] font-black uppercase tracking-widest text-slate-400">
            Banners
            <span class="ml-1.5 px-1.5 py-0.5 bg-slate-100 rounded text-slate-500">{{configData.banners?.length || 0}}</span>
          </span>
          <button (click)="addBanner()" class="btn btn-ghost btn-xs text-primary font-black rounded-lg gap-1 bg-primary/5">
            <i class="fi fi-rs-plus-small text-sm"></i> ADD BANNER
          </button>
        </div>

        <!-- Auto-scroll toggle -->
        <label class="flex items-center justify-between p-3 bg-slate-50 rounded-xl border border-slate-100 cursor-pointer">
          <div>
            <span class="text-xs font-black text-slate-700">Auto-scroll</span>
            <p class="text-[9px] text-slate-400 font-bold mt-0.5">Auto-advance banners every 3s</p>
          </div>
          <input type="checkbox" [(ngModel)]="configData.auto_scroll" (ngModelChange)="emit()" class="toggle toggle-primary toggle-sm">
        </label>

        @if (!configData.banners?.length) {
          <div class="flex flex-col items-center py-8 bg-slate-50 rounded-2xl border border-dashed border-slate-200 text-center opacity-50">
            <i class="fi fi-rs-picture text-3xl text-slate-300 mb-2"></i>
            <p class="text-[10px] font-black uppercase tracking-widest text-slate-400">No banners yet</p>
            <p class="text-[9px] text-slate-400 mt-1">Click ADD BANNER to create the first one</p>
          </div>
        }

        <div class="space-y-4">
          @for (banner of configData.banners; track $index) {
            <div class="p-4 bg-slate-50 rounded-2xl border border-slate-200 relative group/banner">

              <!-- Banner position indicator -->
              <div class="flex items-center justify-between mb-3">
                <span class="text-[9px] font-black uppercase tracking-widest text-slate-400 bg-white border border-slate-200 px-2 py-0.5 rounded-full">
                  Banner {{$index + 1}}
                </span>
                <div class="flex items-center gap-1">
                  <!-- Up/down reorder -->
                  <button (click)="moveBanner($index, $index - 1)" [disabled]="$index === 0"
                    class="btn btn-ghost btn-xs btn-square rounded-lg text-slate-400 hover:text-slate-700 disabled:opacity-20">
                    <i class="fi fi-rs-angle-small-up text-sm"></i>
                  </button>
                  <button (click)="moveBanner($index, $index + 1)" [disabled]="$index === configData.banners.length - 1"
                    class="btn btn-ghost btn-xs btn-square rounded-lg text-slate-400 hover:text-slate-700 disabled:opacity-20">
                    <i class="fi fi-rs-angle-small-down text-sm"></i>
                  </button>
                  <button (click)="removeBanner($index)"
                    class="btn btn-ghost btn-xs btn-square rounded-lg text-red-400 hover:text-red-600 hover:bg-red-50">
                    <i class="fi fi-rs-trash text-xs"></i>
                  </button>
                </div>
              </div>
... (and so on) ...

              <!-- Local image upload + Preview -->
              <div class="space-y-2 mb-3">
                <span class="text-[9px] font-bold text-slate-400 uppercase tracking-wider">Banner Image</span>
                
                <app-image-uploader
                  type="HOME_BANNER"
                  [existingImageUrl]="banner.image_url"
                  (filesSelected)="onBannerFileSelected($event, banner, $index)"
                  (imageRemoved)="banner.image_url = ''; banner._pending_file = null; emit()"
                ></app-image-uploader>
                
                <!-- Live preview -->
                @if (banner.image_url) {
                  <div class="relative aspect-[21/9] rounded-xl overflow-hidden bg-slate-200 mt-2 border border-slate-200">
                    <img [src]="banner.image_url" class="w-full h-full object-cover"
                      alt="Banner preview">
                    <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent pointer-events-none"></div>
                    <div class="absolute bottom-2 left-3 right-3">
                      <p class="text-white font-black text-xs leading-tight line-clamp-1 drop-shadow">{{banner.title || '(no title)'}}</p>
                      <span class="text-white/70 text-[9px] font-bold uppercase">{{banner.cta_text || 'CTA'}}</span>
                    </div>
                  </div>
                }
              </div>

              <div class="grid grid-cols-2 gap-3">
                <div class="space-y-1">
                  <span class="text-[9px] font-bold text-slate-400 uppercase tracking-wider">Headline</span>
                  <div class="flex gap-2">
                    <input type="text" [(ngModel)]="banner.title" (ngModelChange)="emit()"
                      class="input input-sm flex-1 bg-white border-slate-200 rounded-xl text-xs font-bold"
                      placeholder="Big Sale Today!">
                    <input type="color" [(ngModel)]="banner.title_color" (ngModelChange)="emit()"
                      class="input input-sm w-10 p-1 bg-white border-slate-200 rounded-xl shadow-sm cursor-pointer">
                  </div>
                </div>
                <div class="space-y-1">
                  <span class="text-[9px] font-bold text-slate-400 uppercase tracking-wider">Subheading</span>
                  <div class="flex gap-2">
                    <input type="text" [(ngModel)]="banner.subtitle" (ngModelChange)="emit()"
                      class="input input-sm flex-1 bg-white border-slate-200 rounded-xl text-xs font-bold"
                      placeholder="Upto 50% Off">
                    <input type="color" [(ngModel)]="banner.subtitle_color" (ngModelChange)="emit()"
                      class="input input-sm w-10 p-1 bg-white border-slate-200 rounded-xl shadow-sm cursor-pointer">
                  </div>
                </div>
              </div>

              <div class="grid grid-cols-2 gap-3 mt-3">
                <div class="space-y-1">
                  <span class="text-[9px] font-bold text-slate-400 uppercase tracking-wider">CTA Text</span>
                  <input type="text" [(ngModel)]="banner.cta_text" (ngModelChange)="emit()"
                    class="input input-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold"
                    placeholder="Shop Now">
                </div>
                <div class="space-y-1">
                  <span class="text-[9px] font-bold text-slate-400 uppercase tracking-wider">Button Style</span>
                  <div class="flex gap-2">
                    <div class="flex flex-col flex-1">
                      <span class="text-[7px] text-slate-400 font-bold uppercase mb-0.5">Background</span>
                      <input type="color" [(ngModel)]="banner.cta_bg_color" (ngModelChange)="emit()"
                        class="input input-sm w-full p-1 bg-white border-slate-200 rounded-xl shadow-sm cursor-pointer">
                    </div>
                    <div class="flex flex-col flex-1">
                      <span class="text-[7px] text-slate-400 font-bold uppercase mb-0.5">Text</span>
                      <input type="color" [(ngModel)]="banner.cta_text_color" (ngModelChange)="emit()"
                        class="input input-sm w-full p-1 bg-white border-slate-200 rounded-xl shadow-sm cursor-pointer">
                    </div>
                  </div>
                </div>
              </div>

              <div class="space-y-1 mt-3">
                <div class="flex items-center gap-2 mb-1">
                  <span class="text-[9px] flex-1 font-bold text-slate-400 uppercase tracking-wider">Link To</span>
                  <select [(ngModel)]="banner.link_type" (change)="onLinkTypeChange(banner)"
                    class="select select-xs bg-slate-50 border-slate-200 font-bold rounded-lg text-slate-500">
                    <option value="">None</option>
                    <option value="category">Category</option>
                    <option value="collection">Collection</option>
                  </select>
                </div>
                @if (banner.link_type === 'category') {
                  <select (change)="onDeepLinkCategorySelect(banner, $event)" 
                    class="select select-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold mt-1">
                    <option value="">Select Category…</option>
                    @for (cat of flatCategories; track cat.id) {
                      <option [value]="cat.id" [selected]="isCategorySelectedForDeepLink(banner, cat.id)">
                        {{getCategoryIndent(cat.level)}}{{cat.name}}
                      </option>
                    }
                  </select>
                } @else if (banner.link_type === 'collection') {
                  <select (change)="onDeepLinkCollectionSelect(banner, $event)" 
                    class="select select-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold mt-1">
                    <option value="">Select Collection…</option>
                    @for (col of availableCollections; track col.id) {
                      <option [value]="col.slug" [selected]="isCollectionSelectedForDeepLink(banner, col.slug)">
                        {{col.title}}
                      </option>
                    }
                  </select>
                }
                @if (banner.link_url) {
                  <p class="text-[9px] text-slate-400 font-mono mt-1 px-1 truncate">URL: {{banner.link_url}}</p>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }

    <!-- ══════════════════════════════════════════════════════════════════════ -->
    <!-- 2. CATEGORY GRID CONFIGURATOR                                          -->
    <!-- ══════════════════════════════════════════════════════════════════════ -->
    @if (section.type === 'brand_grid') {
      <div class="space-y-6">
        <div class="space-y-1">
          <div class="text-[10px] font-black uppercase tracking-widest text-slate-400">Section Title</div>
          <input type="text" [(ngModel)]="configData.title" (ngModelChange)="emit()"
            class="input input-md w-full bg-slate-50 border-slate-200 font-bold rounded-xl"
            placeholder="Shop by Brands">
        </div>

        <div class="space-y-3">
          <div class="flex items-center justify-between">
            <span class="text-[10px] font-black uppercase tracking-widest text-slate-400">
              Brands
              <span class="ml-1.5 px-1.5 py-0.5 bg-slate-100 rounded text-slate-500">{{configData.brands?.length || 0}}</span>
            </span>
            <span class="text-[10px] font-bold text-slate-400">Tap a brand below</span>
          </div>

          <div class="relative">
            <i class="fi fi-rs-search absolute left-3 top-1/2 -translate-y-1/2 text-slate-300 text-xs"></i>
            <input type="search" [(ngModel)]="brandSearch"
              class="input input-sm w-full bg-slate-50 border-slate-200 rounded-xl text-xs font-bold pl-8"
              placeholder="Search brands">
          </div>

          <div class="grid grid-cols-2 gap-2 max-h-56 overflow-y-auto pr-1 no-scrollbar">
            @for (item of filteredAvailableBrands; track item.id) {
              <button type="button" (click)="selectBrand(item)" [disabled]="isBrandSelected(item.id)"
                class="flex items-center gap-2 p-2 bg-white rounded-xl border border-slate-200 text-left hover:border-primary/30 hover:bg-primary/5 disabled:bg-emerald-50 disabled:border-emerald-100 transition-all">
                <div class="w-9 h-9 rounded-lg bg-slate-50 overflow-hidden border border-slate-100 flex items-center justify-center shrink-0">
                  @if (item.logo || item.icon?.url) {
                    <img [src]="item.logo || item.icon?.url" class="w-full h-full object-contain p-1" alt="">
                  } @else {
                    <i class="fi fi-rs-star text-slate-300"></i>
                  }
                </div>
                <span class="flex-1 text-[11px] font-black text-slate-700 truncate">{{item.name}}</span>
                <i class="fi text-xs" [ngClass]="isBrandSelected(item.id) ? 'fi-rs-check-circle text-emerald-500' : 'fi-rs-plus-small text-primary'"></i>
              </button>
            }
          </div>

          <div class="space-y-2">
            @for (brand of configData.brands; track $index) {
              <div class="flex items-center gap-3 p-3 bg-slate-50 rounded-xl border border-slate-200">
                <div class="w-10 h-10 rounded-xl bg-white border border-slate-200 flex items-center justify-center shrink-0 overflow-hidden">
                  @if (brand.image_url) {
                    <img [src]="brand.image_url" class="w-full h-full object-contain p-1" alt="">
                  } @else {
                    <i class="fi fi-rs-star text-slate-300 text-sm"></i>
                  }
                </div>
                <div class="flex-1 min-w-0">
                  <p class="text-xs font-black text-slate-800 truncate">{{brand.name}}</p>
                  <p class="text-[10px] text-slate-400 font-bold">Position {{$index + 1}}</p>
                </div>
                <div class="flex items-center gap-0.5">
                  <button (click)="moveBrand($index, $index - 1)" [disabled]="$index === 0" class="btn btn-ghost btn-xs btn-square text-slate-400 disabled:opacity-20" title="Move up"><i class="fi fi-rs-angle-small-up"></i></button>
                  <button (click)="moveBrand($index, $index + 1)" [disabled]="$index === configData.brands.length - 1" class="btn btn-ghost btn-xs btn-square text-slate-400 disabled:opacity-20" title="Move down"><i class="fi fi-rs-angle-small-down"></i></button>
                </div>
                <button (click)="removeBrand($index)" class="btn btn-ghost btn-xs btn-square rounded-lg text-red-400 hover:text-red-600 hover:bg-red-50">
                  <i class="fi fi-rs-trash text-xs"></i>
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    }

    @if (section.type === 'offer_strip') {
      <div class="space-y-6">
        <div class="grid grid-cols-2 gap-3">
          <div class="space-y-1">
            <div class="text-[10px] font-black uppercase tracking-widest text-slate-400">Bg Color</div>
            <input type="color" [(ngModel)]="configData.background_color" (ngModelChange)="emit()"
              class="input input-sm w-full bg-slate-50 border-slate-200 rounded-xl p-1">
          </div>
          <div class="space-y-1">
            <div class="text-[10px] font-black uppercase tracking-widest text-slate-400">Text Color</div>
            <input type="color" [(ngModel)]="configData.text_color" (ngModelChange)="emit()"
              class="input input-sm w-full bg-slate-50 border-slate-200 rounded-xl p-1">
          </div>
        </div>

        <div class="space-y-3 p-4 bg-slate-50 rounded-2xl border border-slate-200">
           <div class="space-y-1">
            <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Title</div>
            <input type="text" [(ngModel)]="configData.title" (ngModelChange)="emit()"
              class="input input-sm w-full bg-white border-slate-200 font-bold rounded-xl"
              placeholder="Extra 10% OFF">
          </div>
          <div class="space-y-1">
            <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Subtitle</div>
            <input type="text" [(ngModel)]="configData.subtitle" (ngModelChange)="emit()"
              class="input input-sm w-full bg-white border-slate-200 font-bold rounded-xl"
              placeholder="Use code SUPIDOO10">
          </div>
          <div class="grid grid-cols-2 gap-3">
             <div class="space-y-1">
              <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">CTA Text</div>
              <input type="text" [(ngModel)]="configData.cta_text" (ngModelChange)="emit()"
                class="input input-sm w-full bg-white border-slate-200 font-bold rounded-xl"
                placeholder="Copy">
            </div>
            <div class="space-y-1">
              <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Icon</div>
              <select [(ngModel)]="configData.icon" (ngModelChange)="emit()"
                class="select select-sm w-full bg-white border-slate-200 font-bold rounded-xl">
                <option value="fi-rs-ticket">🎟️ Ticket</option>
                <option value="fi-rs-shopping-bag">🛍️ Bag</option>
                <option value="fi-rs-star">⭐ Star</option>
                <option value="fi-rs-bolt">⚡ Bolt</option>
                <option value="fi-rs-percent"> % Percent</option>
              </select>
            </div>
          </div>
        </div>

        <div class="space-y-1">
          <div class="text-[10px] font-black uppercase tracking-widest text-slate-400">UI Style</div>
          <select [(ngModel)]="configData.ui_type" (ngModelChange)="emit()"
            class="select select-sm w-full bg-slate-50 border-slate-200 font-bold rounded-xl">
            <option value="classic">Classic (Simple)</option>
            <option value="premium">Premium (Gradient)</option>
            <option value="glass">Glass (Translucent)</option>
          </select>
        </div>
      </div>
    }

    @if (section.type === 'category_grid') {
      <div class="space-y-6">
        <div class="space-y-1">
          <div class="text-[10px] font-black uppercase tracking-widest text-slate-400">Grid Section Title (Optional)</div>
          <input type="text" [(ngModel)]="configData.title" (ngModelChange)="emit()"
            class="input input-md w-full bg-slate-50 border-slate-200 font-bold rounded-xl focus:border-primary focus:ring-4 focus:ring-primary/10 transition-all"
            placeholder="e.g. Shop by Category (Leave empty to hide)">
        </div>

        <div class="space-y-3">
          <div class="flex items-center justify-between">
            <span class="text-[10px] font-black uppercase tracking-widest text-slate-400">
              Categories
              <span class="ml-1.5 px-1.5 py-0.5 bg-slate-100 rounded text-slate-500">{{configData.categories?.length || 0}}</span>
            </span>
            <span class="text-[10px] font-bold text-slate-400">Select parent categories</span>
          </div>

          <div class="relative">
            <i class="fi fi-rs-search absolute left-3 top-1/2 -translate-y-1/2 text-slate-300 text-xs"></i>
            <input type="search" [(ngModel)]="categorySearch"
              class="input input-sm w-full bg-slate-50 border-slate-200 rounded-xl text-xs font-bold pl-8"
              placeholder="Search parent categories">
          </div>

          <div class="grid grid-cols-2 gap-2 max-h-64 overflow-y-auto pr-1 no-scrollbar">
            @for (item of filteredAvailableCategories; track item.id) {
              <button type="button" (click)="selectCategory(item)" [disabled]="isCategorySelected(item.id)"
                class="p-2 bg-white rounded-xl border border-slate-200 text-left hover:border-primary/30 hover:bg-primary/5 disabled:bg-emerald-50 disabled:border-emerald-100 transition-all">
                <div class="aspect-square rounded-lg bg-slate-50 overflow-hidden flex items-center justify-center mb-1.5">
                  @if (item.iconUrl) {
                    <img [src]="item.iconUrl" class="w-full h-full object-contain p-2" alt="">
                  } @else {
                    <i class="fi fi-rs-apps text-slate-300 text-xl"></i>
                  }
                </div>
                <div class="flex items-start gap-1">
                  <div class="flex-1 min-w-0">
                    <p class="text-[11px] font-black text-slate-700 truncate">{{item.name}}</p>
                    <p class="text-[9px] font-bold text-slate-400">{{item.children?.length || 0}} categories will show</p>
                  </div>
                  <i class="fi text-xs mt-0.5" [ngClass]="isCategorySelected(item.id) ? 'fi-rs-check-circle text-emerald-500' : 'fi-rs-plus-small text-primary'"></i>
                </div>
              </button>
            }
          </div>

          @if (!configData.categories?.length) {
            <div class="flex flex-col items-center py-8 bg-slate-50 rounded-2xl border border-dashed border-slate-200 text-center opacity-50">
              <i class="fi fi-rs-apps text-3xl text-slate-300 mb-2"></i>
              <p class="text-[10px] font-black uppercase tracking-widest text-slate-400">No categories yet</p>
            </div>
          }

          <div class="space-y-2">
            @for (cat of configData.categories; track $index) {
              <div class="flex items-center gap-3 p-3 bg-slate-50 rounded-xl border border-slate-200">
                <!-- Category image preview -->
                <div class="w-10 h-10 rounded-xl bg-white border border-slate-200 flex items-center justify-center shrink-0 overflow-hidden shadow-sm">
                  @if (cat.image_url) {
                    <img [src]="cat.image_url" class="w-full h-full object-contain p-1" alt="">
                  } @else {
                    <i class="fi fi-rs-apps text-slate-300 text-sm"></i>
                  }
                </div>
                <div class="flex-1 min-w-0">
                  <p class="text-xs font-black text-slate-800 truncate">{{cat.name}}</p>
                  <p class="text-[9px] text-slate-400 font-bold mt-0.5">{{getCategoryChildCount(cat.category_id)}} child categories · Position {{$index + 1}}</p>
                </div>
                <div class="flex items-center gap-0.5">
                  <button (click)="moveCategory($index, $index - 1)" [disabled]="$index === 0" class="btn btn-ghost btn-xs btn-square text-slate-400 disabled:opacity-20" title="Move up"><i class="fi fi-rs-angle-small-up"></i></button>
                  <button (click)="moveCategory($index, $index + 1)" [disabled]="$index === configData.categories.length - 1" class="btn btn-ghost btn-xs btn-square text-slate-400 disabled:opacity-20" title="Move down"><i class="fi fi-rs-angle-small-down"></i></button>
                </div>
                <button (click)="removeCategory($index)" class="btn btn-ghost btn-xs btn-square rounded-lg text-red-400 hover:text-red-600 hover:bg-red-50">
                  <i class="fi fi-rs-trash text-xs"></i>
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    }

    <!-- ══════════════════════════════════════════════════════════════════════ -->
    <!-- 3. PRODUCT SHELF CONFIGURATOR                                          -->
    <!-- ══════════════════════════════════════════════════════════════════════ -->
    @if (section.type === 'collection_banner' || section.type === 'featured_cards' || section.type === 'promo_carousel') {
      <div class="space-y-6">
        <div class="space-y-1">
          <div class="text-[10px] font-black uppercase tracking-widest text-slate-400">Section Title</div>
          <input type="text" [(ngModel)]="configData.title" (ngModelChange)="emit()"
            class="input input-md w-full bg-slate-50 border-slate-200 font-bold rounded-xl focus:border-primary focus:ring-4 focus:ring-primary/10 transition-all"
            placeholder="Featured this week">
        </div>

        @if (section.type === 'collection_banner') {
          <!-- Layout & Style -->
          <div class="space-y-3">
            <span class="text-[10px] font-black uppercase tracking-widest text-slate-400">Choose Layout</span>
            <div class="grid grid-cols-2 gap-2">
              @for (layout of collectionLayouts; track layout.value) {
                <button type="button" (click)="configData.layout_type = layout.value; emit()"
                  class="p-2.5 rounded-xl border text-left transition-all"
                  [ngClass]="configData.layout_type === layout.value ? 'border-primary bg-primary/5 ring-2 ring-primary/10' : 'border-slate-200 bg-white hover:border-primary/30'">
                  <div class="h-9 rounded-lg bg-slate-50 border border-slate-100 p-1.5 mb-2 flex gap-1" [ngClass]="layout.previewClass">
                    <span class="block flex-[2] rounded bg-primary/25"></span>
                    <span class="block flex-1 rounded bg-primary/10"></span>
                    <span class="block flex-1 rounded bg-primary/15"></span>
                  </div>
                  <div class="flex items-center justify-between gap-1">
                    <span class="text-[10px] font-black text-slate-700 truncate">{{layout.label}}</span>
                    @if (configData.layout_type === layout.value) { <i class="fi fi-rs-check-circle text-primary text-xs"></i> }
                  </div>
                </button>
              }
            </div>
          </div>
          @if (!isCollectionProductLayout) {
          <div class="space-y-2">
            <span class="text-[10px] font-black uppercase tracking-widest text-slate-400">Card text style</span>
            <div class="grid grid-cols-2 gap-2">
              @for (style of collectionTextStyles; track style.value) {
                <button type="button" (click)="configData.text_style = style.value; emit()"
                  class="p-2 rounded-xl border text-left transition-all"
                  [ngClass]="(configData.text_style || 'teej') === style.value ? 'border-primary bg-primary/5 ring-2 ring-primary/10' : 'border-slate-200 bg-white hover:border-primary/30'">
                  <span class="text-[10px] font-black text-slate-700">{{style.label}}</span>
                </button>
              }
            </div>
          </div>
          }
          <div class="space-y-3">
            <span class="text-[10px] font-black uppercase tracking-widest text-slate-400">Section Frame</span>
            <label class="flex items-center justify-between p-3 bg-slate-50 rounded-xl border border-slate-100 cursor-pointer">
              <div>
                <span class="text-xs font-black text-slate-700">Edge to edge</span>
                <p class="text-[9px] text-slate-400 font-bold mt-0.5">Full-bleed width with no side inset</p>
              </div>
              <input type="checkbox" [(ngModel)]="configData.edge_to_edge" (ngModelChange)="emit()" class="toggle toggle-primary toggle-sm">
            </label>
            <div class="grid grid-cols-2 gap-2">
              <label class="flex items-center justify-between p-3 bg-slate-50 rounded-xl border border-slate-100 cursor-pointer">
                <span class="text-[11px] font-black text-slate-700">Top border</span>
                <input type="checkbox" [(ngModel)]="configData.show_top_border" (ngModelChange)="emit()" class="toggle toggle-primary toggle-sm">
              </label>
              <label class="flex items-center justify-between p-3 bg-slate-50 rounded-xl border border-slate-100 cursor-pointer">
                <span class="text-[11px] font-black text-slate-700">Bottom border</span>
                <input type="checkbox" [(ngModel)]="configData.show_bottom_border" (ngModelChange)="emit()" class="toggle toggle-primary toggle-sm">
              </label>
            </div>
            @if (configData.show_top_border || configData.show_bottom_border) {
              <div class="space-y-3">
                @if (configData.show_top_border) {
                  <div class="p-3 bg-white rounded-xl border border-slate-200 space-y-2">
                    <span class="text-[9px] font-black uppercase tracking-widest text-slate-400">Top border</span>
                    <div class="grid grid-cols-3 gap-2">
                      @for (style of collectionBorderStyles; track style.value) {
                        <button type="button" (click)="setCollectionBorderStyle('top', style.value)"
                          class="rounded-xl border px-1.5 pt-2 pb-1.5 text-center transition-all"
                          [ngClass]="collectionBorderStyleValue('top') === style.value ? 'border-primary bg-primary/5 ring-2 ring-primary/10' : 'border-slate-200 bg-white hover:border-primary/30'">
                          <span class="block h-3 mb-1.5 rounded-sm overflow-hidden"
                            [ngStyle]="getCollectionBorderThumbStyle(style.value, 'top')"></span>
                          <span class="text-[8px] font-black text-slate-600 leading-tight">{{style.label}}</span>
                        </button>
                      }
                    </div>
                    <div class="grid grid-cols-2 gap-3">
                      <div class="space-y-1">
                        <span class="text-[9px] font-black uppercase tracking-widest text-slate-400">Lace color</span>
                        <input type="color" [(ngModel)]="configData.top_border_color" (ngModelChange)="emit()"
                          class="input input-sm w-full bg-slate-50 border-slate-200 rounded-xl p-1">
                      </div>
                      <div class="space-y-1">
                        <span class="text-[9px] font-black uppercase tracking-widest text-slate-400">Below lace</span>
                        <input type="color" [(ngModel)]="configData.top_border_under_color" (ngModelChange)="emit()"
                          class="input input-sm w-full bg-slate-50 border-slate-200 rounded-xl p-1">
                      </div>
                    </div>
                  </div>
                }
                @if (configData.show_bottom_border) {
                  <div class="p-3 bg-white rounded-xl border border-slate-200 space-y-2">
                    <span class="text-[9px] font-black uppercase tracking-widest text-slate-400">Bottom border</span>
                    <div class="grid grid-cols-3 gap-2">
                      @for (style of collectionBorderStyles; track style.value) {
                        <button type="button" (click)="setCollectionBorderStyle('bottom', style.value)"
                          class="rounded-xl border px-1.5 pt-2 pb-1.5 text-center transition-all"
                          [ngClass]="collectionBorderStyleValue('bottom') === style.value ? 'border-primary bg-primary/5 ring-2 ring-primary/10' : 'border-slate-200 bg-white hover:border-primary/30'">
                          <span class="block h-3 mb-1.5 rounded-sm overflow-hidden"
                            [ngStyle]="getCollectionBorderThumbStyle(style.value, 'bottom')"></span>
                          <span class="text-[8px] font-black text-slate-600 leading-tight">{{style.label}}</span>
                        </button>
                      }
                    </div>
                    <div class="grid grid-cols-2 gap-3">
                      <div class="space-y-1">
                        <span class="text-[9px] font-black uppercase tracking-widest text-slate-400">Lace color</span>
                        <input type="color" [(ngModel)]="configData.bottom_border_color" (ngModelChange)="emit()"
                          class="input input-sm w-full bg-slate-50 border-slate-200 rounded-xl p-1">
                      </div>
                      <div class="space-y-1">
                        <span class="text-[9px] font-black uppercase tracking-widest text-slate-400">Below lace</span>
                        <input type="color" [(ngModel)]="configData.bottom_border_under_color" (ngModelChange)="emit()"
                          class="input input-sm w-full bg-slate-50 border-slate-200 rounded-xl p-1">
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>

          <!-- Main Banner Toggle -->
          <label class="flex items-center justify-between p-3 bg-slate-50 rounded-xl border border-slate-100 cursor-pointer">
            <div>
              <span class="text-xs font-black text-slate-700">Display Hero Banner</span>
              <p class="text-[9px] text-slate-400 font-bold mt-0.5">Toggle the main promotional area</p>
            </div>
            <input type="checkbox" [(ngModel)]="configData.render_main_banner" (ngModelChange)="emit()" class="toggle toggle-primary toggle-sm">
          </label>

          <!-- Main Banner Content -->
          @if (configData.render_main_banner) {
            <div class="p-4 bg-slate-50 rounded-2xl border border-slate-200 space-y-4">
              <span class="text-[10px] font-black uppercase tracking-widest text-slate-600">Main Banner Content</span>
              
              <app-image-uploader
                type="COLLECTION_SECTION_HEADER"
                [existingImageUrl]="configData.main_banner?.image_url"
                (filesSelected)="onVisualFileSelected($event, configData.main_banner, 'collection-main-banner')"
                (imageRemoved)="configData.main_banner.image_url = ''; configData.main_banner._pending_file = null; emit()"
              ></app-image-uploader>

              @if (configData.main_banner?.image_url) {
                <div class="aspect-[10/3] rounded-xl overflow-hidden border border-slate-200 bg-white">
                  <img [src]="configData.main_banner.image_url" class="w-full h-full object-cover" alt="">
                </div>
              }

              <div class="space-y-3">
                <div class="space-y-1">
                  <span class="text-[9px] font-bold text-slate-400 uppercase">Banner Headline</span>
                  <input type="text" [(ngModel)]="configData.main_banner.title" (ngModelChange)="emit()"
                    class="input input-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold" placeholder="e.g. Fresh Arrivals">
                </div>
                <div class="space-y-1">
                  <span class="text-[9px] font-bold text-slate-400 uppercase">Banner Subheading</span>
                  <textarea [(ngModel)]="configData.main_banner.subtitle" (ngModelChange)="emit()"
                    class="textarea textarea-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold leading-tight" rows="2" placeholder="Describe the collection..."></textarea>
                </div>
                <div class="grid grid-cols-2 gap-3">
                   <div class="space-y-1">
                    <span class="text-[9px] font-bold text-slate-400 uppercase">Badge / CTA</span>
                    <input type="text" [(ngModel)]="configData.main_banner.cta_text" (ngModelChange)="emit()"
                      class="input input-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold" placeholder="UP TO 75% OFF">
                  </div>
                  <div class="space-y-1">
                    <span class="text-[9px] font-bold text-slate-400 uppercase">Powered By</span>
                    <input type="text" [(ngModel)]="configData.main_banner.brand" (ngModelChange)="emit()"
                      class="input input-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold" placeholder="Vatika">
                  </div>
                </div>
                <div class="grid grid-cols-1 gap-3">
                   <div class="space-y-1">
                    <div class="flex items-center justify-between mb-1">
                      <span class="text-[9px] font-bold text-slate-400 uppercase">Link To</span>
                      <select [(ngModel)]="configData.main_banner.link_type" (change)="onLinkTypeChange(configData.main_banner)"
                        class="select select-xs bg-slate-50 border-slate-200 font-bold rounded-lg text-slate-500">
                        <option value="">None</option>
                        <option value="category">Category</option>
                        <option value="collection">Collection</option>
                      </select>
                    </div>
                    @if (configData.main_banner.link_type === 'category') {
                      <select (change)="onDeepLinkCategorySelect(configData.main_banner, $event)" 
                        class="select select-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold mt-1">
                        <option value="">Select Category…</option>
                        @for (cat of flatCategories; track cat.id) {
                          <option [value]="cat.id" [selected]="isCategorySelectedForDeepLink(configData.main_banner, cat.id)">
                            {{getCategoryIndent(cat.level)}}{{cat.name}}
                          </option>
                        }
                      </select>
                    } @else if (configData.main_banner.link_type === 'collection') {
                      <select (change)="onDeepLinkCollectionSelect(configData.main_banner, $event)" 
                        class="select select-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold mt-1">
                        <option value="">Select Collection…</option>
                        @for (col of availableCollections; track col.id) {
                          <option [value]="col.slug" [selected]="isCollectionSelectedForDeepLink(configData.main_banner, col.slug)">
                            {{col.title}}
                          </option>
                        }
                      </select>
                    }
                  </div>
                </div>
              </div>
            </div>
          }

          <label class="flex items-center justify-between p-3 bg-slate-50 rounded-xl border border-slate-100 cursor-pointer">
            <div>
              <span class="text-xs font-black text-slate-700">Bottom offer strip</span>
              <p class="text-[9px] text-slate-400 font-bold mt-0.5">Show a promo row under this section</p>
            </div>
            <input type="checkbox" [(ngModel)]="configData.show_bottom_offer" (ngModelChange)="emit()" class="toggle toggle-primary toggle-sm">
          </label>

          @if (configData.show_bottom_offer) {
            <div class="p-4 bg-cyan-50 rounded-2xl border border-cyan-100 space-y-4">
              <span class="text-[10px] font-black uppercase tracking-widest text-cyan-800">Offer strip</span>
              <div class="grid grid-cols-2 gap-2">
                @for (design of collectionOfferDesigns; track design.value) {
                  <button type="button" (click)="configData.bottom_offer.design = design.value; emit()"
                    class="p-2 rounded-xl border text-left bg-white transition-all"
                    [ngClass]="(configData.bottom_offer?.design || 'card') === design.value ? 'border-primary ring-2 ring-primary/10' : 'border-cyan-100'">
                    <span class="text-[10px] font-black text-slate-700">{{design.label}}</span>
                  </button>
                }
              </div>
              <div class="grid grid-cols-2 gap-3">
                <div class="space-y-1">
                  <span class="text-[9px] font-bold text-slate-500 uppercase">Offer Title</span>
                  <input type="text" [(ngModel)]="configData.bottom_offer.title" (ngModelChange)="emit()"
                    class="input input-sm w-full bg-white border-cyan-100 rounded-xl text-xs font-bold"
                    placeholder="Buy 2 get Upto 15% Off">
                </div>
                <div class="space-y-2">
                  <span class="text-[9px] font-bold text-slate-500 uppercase">Offer images (up to 3)</span>
                  <p class="text-[9px] font-bold text-slate-400 -mt-1">Upload from this device. They publish with the section.</p>
                  <div class="grid grid-cols-3 gap-2">
                    @for (slot of (configData.bottom_offer.images || []); track $index) {
                      <div class="rounded-xl border border-cyan-100 bg-white space-y-1 overflow-hidden">
                        <app-image-uploader
                          type="COLLECTION_OFFER_ICON"
                          [existingImageUrl]="slot.image_url"
                          (filesSelected)="onOfferImageSelected($event, $index)"
                          (imageRemoved)="clearOfferImage($index)"
                        ></app-image-uploader>
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="space-y-1">
                <span class="text-[9px] font-bold text-slate-500 uppercase">Offer Subtitle</span>
                <input type="text" [(ngModel)]="configData.bottom_offer.subtitle" (ngModelChange)="emit()"
                  class="input input-sm w-full bg-white border-cyan-100 rounded-xl text-xs font-bold"
                  placeholder="Loreal, Garnier & L'oreal Professional">
              </div>
            </div>
          }

          @if (isCollectionProductLayout) {
            <div class="space-y-2">
              <span class="text-[10px] font-black uppercase tracking-widest text-slate-400">Product list style</span>
              <div class="grid grid-cols-2 gap-2">
                @for (style of collectionProductStyles; track style.value) {
                  <button type="button" (click)="configData.product_style = style.value; emit()"
                    class="p-2 rounded-xl border text-left transition-all"
                    [ngClass]="(configData.product_style || 'product_card') === style.value ? 'border-primary bg-primary/5 ring-2 ring-primary/10' : 'border-slate-200 bg-white hover:border-primary/30'">
                    <span class="text-[10px] font-black text-slate-700">{{style.label}}</span>
                  </button>
                }
              </div>
            </div>
          }

          @if (configData.layout_type === 'product_picks') {
            <div class="space-y-3">
              <div class="space-y-2">
                <span class="text-[10px] font-black uppercase tracking-widest text-slate-400">Product display</span>
                <div class="grid grid-cols-2 gap-2">
                  <button type="button" (click)="configData.product_display_style = 'grid'; emit()"
                    class="p-2 rounded-xl border text-left transition-all"
                    [ngClass]="(configData.product_display_style || 'grid') === 'grid' ? 'border-primary bg-primary/5 ring-2 ring-primary/10' : 'border-slate-200 bg-white hover:border-primary/30'">
                    <span class="text-[10px] font-black text-slate-700">Product Grid</span>
                    <p class="mt-0.5 text-[9px] text-slate-400">Shows up to 6 products</p>
                  </button>
                  <button type="button" (click)="configData.product_display_style = 'two_row'; emit()"
                    class="p-2 rounded-xl border text-left transition-all"
                    [ngClass]="configData.product_display_style === 'two_row' ? 'border-primary bg-primary/5 ring-2 ring-primary/10' : 'border-slate-200 bg-white hover:border-primary/30'">
                    <span class="text-[10px] font-black text-slate-700">2-Row Product List</span>
                    <p class="mt-0.5 text-[9px] text-slate-400">Shows up to 6 products</p>
                  </button>
                </div>
              </div>
              <span class="text-[10px] font-black uppercase tracking-widest text-slate-400">Product query</span>
              <p class="text-[9px] font-bold text-slate-400 -mt-2">Products from this category appear in the festive picks rail.</p>
              <div class="p-4 bg-slate-50 rounded-xl border border-slate-200 space-y-4">
                <div class="space-y-1">
                  <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Category</div>
                  <select [(ngModel)]="configData.data_source.query.category_id" (ngModelChange)="emit()"
                    class="select select-xs w-full bg-white border-slate-200 font-bold rounded-lg">
                    <option [ngValue]="undefined">Select category…</option>
                    @for (category of flatCategories; track category.id) {
                      <option [ngValue]="'' + category.id">
                        {{getCategoryIndent(category.level)}}{{category.name}}
                      </option>
                    }
                  </select>
                </div>
                <div class="flex items-center justify-between">
                  <span class="text-xs font-black text-slate-700">Max products</span>
                  <input type="number" [(ngModel)]="configData.data_source.query.limit" (ngModelChange)="emit()"
                    class="input input-xs w-16 bg-white border-slate-200 text-center font-black rounded-lg" min="1" max="50">
                </div>
                <div class="flex items-center justify-between">
                  <span class="text-xs font-black text-slate-700">Sort</span>
                  <select [(ngModel)]="configData.data_source.query.sort_by" (ngModelChange)="emit()"
                    class="select select-xs bg-white border-slate-200 font-bold rounded-lg">
                    <option value="featured">Featured</option>
                    <option value="newest">Newest</option>
                    <option value="bestseller">Best sellers</option>
                    <option value="price_asc">Price low-high</option>
                    <option value="price_desc">Price high-low</option>
                  </select>
                </div>
              </div>
            </div>
          }

          @if (configData.layout_type === 'category_essentials') {
            <div class="space-y-3">
              <span class="text-[10px] font-black uppercase tracking-widest text-slate-400">Category chip style</span>
              <div class="grid grid-cols-2 gap-2">
                @for (style of collectionChipStyles; track style.value) {
                  <button type="button" (click)="configData.chip_style = style.value; emit()"
                    class="group relative min-h-[92px] overflow-hidden rounded-2xl border p-2.5 text-left transition-all"
                    [ngClass]="(configData.chip_style || 'circle') === style.value ? 'border-primary bg-primary/5 ring-2 ring-primary/10' : 'border-slate-200 bg-white hover:border-primary/30'">
                    <div class="mb-2 flex h-9 items-center gap-1.5 rounded-xl bg-slate-100/80 px-2">
                      @switch (style.value) {
                        @case ('pill') {
                          <span class="flex h-6 items-center gap-1 rounded-full border border-slate-200 bg-white px-1.5">
                            <span class="size-4 rounded-full bg-gradient-to-br from-amber-200 to-orange-400"></span>
                            <span class="h-1.5 w-7 rounded-full bg-slate-300"></span>
                          </span>
                        }
                        @case ('tile') {
                          <span class="flex items-end gap-1">
                            <span class="size-7 rounded-lg border-2 border-primary bg-gradient-to-br from-amber-100 to-orange-300"></span>
                            <span class="size-6 rounded-lg bg-white shadow-sm"></span>
                          </span>
                        }
                        @case ('bar') {
                          <span class="h-6 w-12 rounded-full border border-primary bg-white"></span>
                          <span class="h-6 w-9 rounded-full bg-slate-200"></span>
                        }
                        @case ('framed') {
                          <span class="h-8 w-7 rounded-lg border border-primary bg-white p-0.5">
                            <span class="block h-5 rounded-md bg-gradient-to-br from-amber-100 to-orange-300"></span>
                          </span>
                          <span class="h-7 w-6 rounded-lg border border-slate-200 bg-white p-0.5"></span>
                        }
                        @default {
                          <span class="size-7 rounded-full border-2 border-primary bg-gradient-to-br from-amber-100 to-orange-300"></span>
                          <span class="size-6 rounded-full bg-white shadow-sm"></span>
                        }
                      }
                    </div>
                    <span class="block text-[10px] font-black text-slate-700">{{style.label}}</span>
                    <span class="mt-0.5 block text-[8px] font-bold leading-tight text-slate-400">{{style.description}}</span>
                    @if ((configData.chip_style || 'circle') === style.value) {
                      <span class="absolute right-2 top-2 flex size-4 items-center justify-center rounded-full bg-primary text-white">
                        <i class="fi fi-rs-check text-[8px]"></i>
                      </span>
                    }
                  </button>
                }
              </div>
            </div>
            <div class="space-y-3 rounded-2xl border border-slate-200 bg-slate-50 p-3">
              <div>
                <span class="text-[10px] font-black uppercase tracking-widest text-slate-500">Category chip colors</span>
                <p class="mt-0.5 text-[9px] font-bold text-slate-400">Applied independently from the section title color.</p>
              </div>
              <div class="grid grid-cols-3 gap-3">
                <label class="space-y-1">
                  <span class="text-[9px] font-black uppercase tracking-widest text-slate-400">Selected</span>
                  <input type="color" [(ngModel)]="configData.chip_selected_text_color" (ngModelChange)="emit()"
                    class="input input-sm w-full rounded-xl border-slate-200 bg-white p-1">
                </label>
                <label class="space-y-1">
                  <span class="text-[9px] font-black uppercase tracking-widest text-slate-400">Unselected</span>
                  <input type="color" [(ngModel)]="configData.chip_unselected_text_color" (ngModelChange)="emit()"
                    class="input input-sm w-full rounded-xl border-slate-200 bg-white p-1">
                </label>
                <label class="space-y-1">
                  <span class="text-[9px] font-black uppercase tracking-widest text-slate-400">Border</span>
                  <input type="color" [(ngModel)]="configData.chip_selected_border_color" (ngModelChange)="emit()"
                    class="input input-sm w-full rounded-xl border-slate-200 bg-white p-1">
                </label>
              </div>
            </div>
            <div class="space-y-3">
              <div class="flex items-center justify-between">
                <div>
                  <span class="text-[10px] font-black uppercase tracking-widest text-slate-400">Category chips</span>
                  <p class="text-[9px] font-bold text-slate-400 mt-0.5">Each chip loads products from that category.</p>
                </div>
                <button (click)="addCategory()" class="btn btn-ghost btn-xs text-primary font-black rounded-lg gap-1 bg-primary/5">
                  <i class="fi fi-rs-plus-small text-sm"></i> ADD
                </button>
              </div>
              <div class="space-y-2">
                @for (cat of configData.categories; track $index) {
                  <div class="p-3 bg-slate-50 rounded-xl border border-slate-200 space-y-2">
                    <div class="flex items-center justify-between">
                      <span class="text-[9px] font-black text-slate-400">Chip {{$index + 1}}</span>
                      <button (click)="removeCategory($index)" class="btn btn-ghost btn-xs btn-square text-red-400"><i class="fi fi-rs-trash text-xs"></i></button>
                    </div>
                    <select (change)="onCategorySelect(cat, $event)" class="select select-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold">
                      <option value="">Select category…</option>
                      @for (option of flatCategories; track option.id) {
                        <option [value]="option.id" [selected]="cat.category_id === ('' + option.id)">
                          {{getCategoryIndent(option.level)}}{{option.name}}
                        </option>
                      }
                    </select>
                  </div>
                }
              </div>
            </div>
          }

          <div class="space-y-3">
            <div class="space-y-1">
              <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Section Subtitle</div>
              <input type="text" [(ngModel)]="configData.subtitle" (ngModelChange)="emit()"
                class="input input-sm w-full bg-slate-50 border-slate-200 font-bold rounded-xl"
                placeholder="School essentials">
            </div>
            <div class="space-y-2">
              <span class="text-[10px] font-black uppercase tracking-widest text-slate-400">Background</span>
              <div class="grid grid-cols-2 gap-2">
                <button type="button" (click)="configData.background_type = 'solid'; emit()"
                  class="p-2.5 rounded-xl border text-left transition-all"
                  [ngClass]="configData.background_type !== 'gradient' ? 'border-primary bg-primary/5 ring-2 ring-primary/10' : 'border-slate-200 bg-white hover:border-primary/30'">
                  <span class="text-[10px] font-black text-slate-700">Solid</span>
                </button>
                <button type="button" (click)="configData.background_type = 'gradient'; emit()"
                  class="p-2.5 rounded-xl border text-left transition-all"
                  [ngClass]="configData.background_type === 'gradient' ? 'border-primary bg-primary/5 ring-2 ring-primary/10' : 'border-slate-200 bg-white hover:border-primary/30'">
                  <span class="text-[10px] font-black text-slate-700">Gradient</span>
                </button>
              </div>
              <div class="grid grid-cols-2 gap-3">
                <div class="space-y-1">
                  <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">
                    {{configData.background_type === 'gradient' ? 'Start color' : 'Background color'}}
                  </div>
                  <input type="color" [(ngModel)]="configData.background_color" (ngModelChange)="emit()"
                    class="input input-sm w-full bg-slate-50 border-slate-200 rounded-xl p-1">
                </div>
                @if (configData.background_type === 'gradient') {
                  <div class="space-y-1">
                    <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">End color</div>
                    <input type="color" [(ngModel)]="configData.background_color_end" (ngModelChange)="emit()"
                      class="input input-sm w-full bg-slate-50 border-slate-200 rounded-xl p-1">
                  </div>
                }
              </div>
              @if (configData.background_type === 'gradient') {
                <div class="space-y-1">
                  <div class="flex items-center justify-between">
                    <span class="text-[9px] font-black uppercase tracking-widest text-slate-400">Rotate gradient</span>
                    <span class="text-[10px] font-black text-slate-500">{{configData.gradient_angle || 0}}°</span>
                  </div>
                  <input type="range" min="0" max="360" step="1"
                    [(ngModel)]="configData.gradient_angle" (ngModelChange)="emit()"
                    class="range range-xs range-primary">
                  <div class="h-8 rounded-xl border border-slate-200"
                    [style.background]="'linear-gradient(' + (configData.gradient_angle || 0) + 'deg, ' + (configData.background_color || '#7A2E0E') + ', ' + (configData.background_color_end || '#F6D7A4') + ')'">
                  </div>
                </div>
              }
            </div>
          </div>

          <div class="space-y-1">
            <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Text Align</div>
            <select [(ngModel)]="configData.text_align" (ngModelChange)="emit()"
              class="select select-sm w-full bg-slate-50 border-slate-200 font-bold rounded-xl">
              <option value="left">Left</option>
              <option value="center">Center</option>
              <option value="right">Right</option>
            </select>
          </div>
          <div class="grid grid-cols-2 gap-3">
            <div class="space-y-1">
              <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Title color</div>
              <input type="color" [(ngModel)]="configData.title_color" (ngModelChange)="emit()"
                class="input input-sm w-full bg-slate-50 border-slate-200 rounded-xl p-1">
            </div>
            <div class="space-y-1">
              <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Subtitle color</div>
              <input type="color" [(ngModel)]="configData.subtitle_color" (ngModelChange)="emit()"
                class="input input-sm w-full bg-slate-50 border-slate-200 rounded-xl p-1">
            </div>
          </div>
        }

        @if (!(section.type === 'collection_banner' && isCollectionProductLayout)) {
        <div class="space-y-3">
          <div class="flex items-center justify-between">
            <span class="text-[10px] font-black uppercase tracking-widest text-slate-400">
              {{section.type === 'promo_carousel' ? 'Promo Cards' : 'Visual Cards'}}
              <span class="ml-1.5 px-1.5 py-0.5 bg-slate-100 rounded text-slate-500">
                {{(section.type === 'promo_carousel' ? configData.cards?.length : configData.items?.length) || 0}}
              </span>
            </span>
            <button (click)="addVisualItem(section.type === 'promo_carousel' ? 'cards' : 'items')"
              class="btn btn-ghost btn-xs text-primary font-black rounded-lg gap-1 bg-primary/5">
              <i class="fi fi-rs-plus-small text-sm"></i> ADD
            </button>
          </div>

          <div class="space-y-4">
            @for (item of (section.type === 'promo_carousel' ? configData.cards : configData.items); track $index) {
              <div class="p-4 bg-slate-50 rounded-2xl border border-slate-200 space-y-3">
                <div class="flex items-center justify-between">
                  <span class="text-[9px] font-black uppercase tracking-widest text-slate-400 bg-white border border-slate-200 px-2 py-0.5 rounded-full">
                    Card {{$index + 1}}
                  </span>
                  <div class="flex items-center gap-0.5">
                    <button (click)="moveVisualItem(section.type === 'promo_carousel' ? 'cards' : 'items', $index, $index - 1)" [disabled]="$index === 0" class="btn btn-ghost btn-xs btn-square text-slate-400 disabled:opacity-20" title="Move up"><i class="fi fi-rs-angle-small-up"></i></button>
                    <button (click)="moveVisualItem(section.type === 'promo_carousel' ? 'cards' : 'items', $index, $index + 1)" [disabled]="$index === (section.type === 'promo_carousel' ? configData.cards.length : configData.items.length) - 1" class="btn btn-ghost btn-xs btn-square text-slate-400 disabled:opacity-20" title="Move down"><i class="fi fi-rs-angle-small-down"></i></button>
                    <button (click)="removeVisualItem(section.type === 'promo_carousel' ? 'cards' : 'items', $index)"
                      class="btn btn-ghost btn-xs btn-square rounded-lg text-red-400 hover:text-red-600 hover:bg-red-50">
                      <i class="fi fi-rs-trash text-xs"></i>
                    </button>
                  </div>
                </div>

                <app-image-uploader
                  [type]="visualCardUploadType"
                  [existingImageUrl]="item.image_url || ''"
                  (filesSelected)="onVisualFileSelected($event, item, section.type + '-' + $index)"
                  (imageRemoved)="item.image_url = ''; item._pending_file = null; emit()"
                ></app-image-uploader>

                <div class="grid grid-cols-2 gap-3">
                  <div class="space-y-1">
                    <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Title</div>
                    <input type="text" [(ngModel)]="item.title" (ngModelChange)="emit()"
                      class="input input-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold"
                      placeholder="Bags for every outfit">
                  </div>
                  <div class="space-y-1">
                    <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Badge</div>
                    <input type="text" [(ngModel)]="item.badge" (ngModelChange)="emit()"
                      class="input input-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold"
                      placeholder="Featured">
                  </div>
                </div>

                @if (section.type === 'promo_carousel') {
                  <div class="grid grid-cols-2 gap-3">
                    <div class="space-y-1">
                      <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Subtitle</div>
                      <input type="text" [(ngModel)]="item.subtitle" (ngModelChange)="emit()"
                        class="input input-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold"
                        placeholder="Get tote bags, backpacks & more">
                    </div>
                    <div class="space-y-1">
                      <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">CTA</div>
                      <input type="text" [(ngModel)]="item.cta_text" (ngModelChange)="emit()"
                        class="input input-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold"
                        placeholder="Shop now">
                    </div>
                  </div>
                }

                <div class="grid grid-cols-3 gap-3">
                  <div class="space-y-1">
                    <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Card BG</div>
                    <input type="color" [(ngModel)]="item.background_color" (ngModelChange)="emit()"
                      class="input input-sm w-full bg-white border-slate-200 rounded-xl p-1">
                  </div>
                  <div class="space-y-1">
                    <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Border</div>
                    <input type="color" [(ngModel)]="item.border_color" (ngModelChange)="emit()"
                      class="input input-sm w-full bg-white border-slate-200 rounded-xl p-1">
                  </div>
                  <div class="space-y-1">
                    <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Text</div>
                    <input type="color" [(ngModel)]="item.text_color" (ngModelChange)="emit()"
                      class="input input-sm w-full bg-white border-slate-200 rounded-xl p-1">
                  </div>
                </div>

                <div class="space-y-1">
                  <div class="flex items-center gap-2 mb-1">
                    <span class="text-[9px] flex-1 font-black uppercase tracking-widest text-slate-400">Link To</span>
                    <select [(ngModel)]="item.link_type" (change)="onLinkTypeChange(item)"
                      class="select select-xs bg-slate-50 border-slate-200 font-bold rounded-lg text-slate-500">
                      <option value="">None</option>
                      <option value="category">Category</option>
                      <option value="collection">Collection</option>
                    </select>
                  </div>
                  @if (item.link_type === 'category') {
                    <select (change)="onDeepLinkCategorySelect(item, $event)" 
                      class="select select-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold mt-1">
                      <option value="">Select Category…</option>
                      @for (cat of flatCategories; track cat.id) {
                        <option [value]="cat.id" [selected]="isCategorySelectedForDeepLink(item, cat.id)">
                          {{getCategoryIndent(cat.level)}}{{cat.name}}
                        </option>
                      }
                    </select>
                  } @else if (item.link_type === 'collection') {
                    <select (change)="onDeepLinkCollectionSelect(item, $event)" 
                      class="select select-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold mt-1">
                      <option value="">Select Collection…</option>
                      @for (col of availableCollections; track col.id) {
                        <option [value]="col.slug" [selected]="isCollectionSelectedForDeepLink(item, col.slug)">
                          {{col.title}}
                        </option>
                      }
                    </select>
                  }
                  @if (item.link_url) {
                    <p class="text-[9px] text-slate-400 font-mono mt-1 px-1 truncate">URL: {{item.link_url}}</p>
                  }
                </div>
              </div>
            }
          </div>
        </div>
        }

      </div>
    }

    @if (section.type === 'hero_showcase') {
      <div class="space-y-6 pb-6">
        <!-- Layout & UI Type -->
        <div class="grid grid-cols-2 gap-4">
          <div class="space-y-1">
            <span class="text-[9px] font-black uppercase tracking-widest text-slate-400">Layout</span>
            <select [(ngModel)]="configData.layout_type" (ngModelChange)="emit()" 
              class="select select-sm w-full bg-slate-50 border-slate-200 font-bold rounded-xl">
              <option value="banner_top_cards_bottom">Banner Top, Cards Bottom</option>
              <option value="banner_left_cards_right">Banner Left, Cards Right</option>
              <option value="banner_top_grid">Banner Top, Grid Bottom</option>
              <option value="banner_background_cards_overlay">Banner BG, Cards Overlay</option>
            </select>
          </div>
          <div class="space-y-1">
            <span class="text-[9px] font-black uppercase tracking-widest text-slate-400">UI Style</span>
            <select [(ngModel)]="configData.ui_type" (ngModelChange)="emit()" 
              class="select select-sm w-full bg-slate-50 border-slate-200 font-bold rounded-xl">
              <option value="modern">Modern</option>
              <option value="premium">Premium</option>
              <option value="classic">Classic</option>
              <option value="festival">Festival</option>
            </select>
          </div>
        </div>

        <!-- Container Settings -->
        <div class="p-4 bg-slate-50 rounded-2xl border border-slate-200 space-y-4">
          <span class="text-[10px] font-black uppercase tracking-widest text-slate-600 block mb-2">Container Style</span>
          <div class="grid grid-cols-2 gap-3">
            <div class="space-y-1">
              <span class="text-[9px] font-bold text-slate-400 uppercase">Background</span>
              <input type="color" [(ngModel)]="configData.container.background_color" (ngModelChange)="emit()"
                class="input input-sm w-full bg-white border-slate-200 rounded-xl p-1">
            </div>
            <div class="space-y-1">
              <span class="text-[9px] font-bold text-slate-400 uppercase">Padding (px)</span>
              <input type="number" [(ngModel)]="configData.container.padding" (ngModelChange)="emit()"
                class="input input-sm w-full bg-white border-slate-200 rounded-xl font-bold">
            </div>
          </div>
          <div class="flex items-center justify-between">
            <span class="text-xs font-black text-slate-700">Drop Shadow</span>
            <input type="checkbox" [(ngModel)]="configData.container.shadow" (ngModelChange)="emit()" 
              class="toggle toggle-primary toggle-sm">
          </div>
        </div>

        <!-- Main Banner Settings -->
        <div class="p-4 bg-slate-50 rounded-2xl border border-slate-200 space-y-4">
          <span class="text-[10px] font-black uppercase tracking-widest text-slate-600 block mb-2">Main Banner</span>
          
          <app-image-uploader
            type="COLLECTION_SECTION_HEADER"
            [existingImageUrl]="configData.banner?.image_url || ''"
            (filesSelected)="onVisualFileSelected($event, configData.banner, 'hero-banner')"
            (imageRemoved)="configData.banner.image_url = ''; configData.banner._pending_file = null; emit()"
          ></app-image-uploader>

          <div class="space-y-3">
            <div class="space-y-1">
              <span class="text-[9px] font-bold text-slate-400 uppercase">Title</span>
              <input type="text" [(ngModel)]="configData.banner.title" (ngModelChange)="emit()"
                class="input input-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold">
            </div>
            <div class="space-y-1">
              <span class="text-[9px] font-bold text-slate-400 uppercase">Subtitle</span>
              <input type="text" [(ngModel)]="configData.banner.subtitle" (ngModelChange)="emit()"
                class="input input-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold">
            </div>
            <div class="grid grid-cols-2 gap-3">
               <div class="space-y-1">
                <span class="text-[9px] font-bold text-slate-400 uppercase">CTA Text</span>
                <input type="text" [(ngModel)]="configData.banner.cta_text" (ngModelChange)="emit()"
                  class="input input-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold">
              </div>
               <div class="space-y-1">
                <div class="flex items-center justify-between mb-1">
                  <span class="text-[9px] font-bold text-slate-400 uppercase">Link To</span>
                  <select [(ngModel)]="configData.banner.link_type" (change)="onLinkTypeChange(configData.banner)"
                    class="select select-xs bg-slate-50 border-slate-200 font-bold rounded-lg text-slate-500">
                    <option value="">None</option>
                    <option value="category">Category</option>
                    <option value="collection">Collection</option>
                  </select>
                </div>
                @if (configData.banner.link_type === 'category') {
                  <select (change)="onDeepLinkCategorySelect(configData.banner, $event)" 
                    class="select select-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold mt-1">
                    <option value="">Select Category…</option>
                    @for (cat of flatCategories; track cat.id) {
                      <option [value]="cat.id" [selected]="isCategorySelectedForDeepLink(configData.banner, cat.id)">
                        {{cat.name}}
                      </option>
                    }
                  </select>
                } @else if (configData.banner.link_type === 'collection') {
                  <select (change)="onDeepLinkCollectionSelect(configData.banner, $event)" 
                    class="select select-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold mt-1">
                    <option value="">Select Collection…</option>
                    @for (col of availableCollections; track col.id) {
                      <option [value]="col.slug" [selected]="isCollectionSelectedForDeepLink(configData.banner, col.slug)">
                        {{col.title}}
                      </option>
                    }
                  </select>
                }
              </div>
            </div>
          </div>
        </div>

        <!-- Cards List -->
        <div class="space-y-4">
          <div class="flex items-center justify-between">
            <span class="text-[10px] font-black uppercase tracking-widest text-slate-400">
              Cards
              <span class="ml-1.5 px-1.5 py-0.5 bg-slate-100 rounded text-slate-500">{{configData.cards?.length || 0}}</span>
            </span>
            <button (click)="addHeroCard()" class="btn btn-ghost btn-xs text-primary font-black rounded-lg gap-1 bg-primary/5">
              <i class="fi fi-rs-plus-small text-sm"></i> ADD CARD
            </button>
          </div>

          <div class="grid gap-4">
            @for (card of configData.cards; track $index) {
              <div class="p-4 bg-slate-50 rounded-2xl border border-slate-200 relative group/card">
                <div class="flex justify-end gap-0.5 mb-2">
                  <button (click)="moveHeroCard($index, $index - 1)" [disabled]="$index === 0" class="btn btn-ghost btn-xs btn-square text-slate-400 disabled:opacity-20" title="Move up"><i class="fi fi-rs-angle-small-up"></i></button>
                  <button (click)="moveHeroCard($index, $index + 1)" [disabled]="$index === configData.cards.length - 1" class="btn btn-ghost btn-xs btn-square text-slate-400 disabled:opacity-20" title="Move down"><i class="fi fi-rs-angle-small-down"></i></button>
                  <button (click)="removeHeroCard($index)" class="btn btn-ghost btn-xs btn-square text-red-400 hover:text-red-600" title="Remove card"><i class="fi fi-rs-trash text-xs"></i></button>
                </div>
                
                <div class="flex flex-col gap-4">
                  <div>
                    <app-image-uploader
                      type="FEATURED_CARD"
                      [existingImageUrl]="card.image_url"
                      (filesSelected)="onVisualFileSelected($event, card, 'hero-card-' + $index)"
                      (imageRemoved)="card.image_url = ''; card._pending_file = null; emit()"
                    ></app-image-uploader>
                  </div>
                  <div class="flex-1 space-y-2">
                    <input type="text" [(ngModel)]="card.title" (ngModelChange)="emit()"
                      class="input input-xs w-full bg-white border-slate-200 rounded-lg font-bold" placeholder="Card Title">
                    <div class="grid grid-cols-2 gap-2">
                      <input type="text" [(ngModel)]="card.badge" (ngModelChange)="emit()"
                        class="input input-xs w-full bg-white border-slate-200 rounded-lg text-[10px]" placeholder="Badge (e.g. 20% OFF)">
                      <input type="color" [(ngModel)]="card.background_color" (ngModelChange)="emit()"
                        class="input input-xs w-full bg-white border-slate-200 rounded-lg p-0.5">
                    </div>
                  </div>
                </div>
                <!-- removed trailing guide wrapper as uploader has guide inside -->
              </div>
            }
          </div>
        </div>
      </div>
    }
    
    @if (section.type === 'product_shelf') {
      <div class="space-y-6">
        <div class="space-y-1">
          <div class="text-[10px] font-black uppercase tracking-widest text-slate-400">Shelf Title</div>
          <input type="text" [(ngModel)]="configData.title" (ngModelChange)="emit()"
            class="input input-md w-full bg-slate-50 border-slate-200 font-bold rounded-xl focus:border-primary focus:ring-4 focus:ring-primary/10 transition-all"
            placeholder="Must Try Items">
        </div>

        <div class="grid grid-cols-4 gap-3">
          <div class="space-y-1 col-span-2">
            <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Subtitle</div>
            <input type="text" [(ngModel)]="configData.subtitle" (ngModelChange)="emit()"
              class="input input-sm w-full bg-slate-50 border-slate-200 font-bold rounded-xl"
              placeholder="On summer coolers">
          </div>
          <div class="space-y-1">
            <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Bg Color</div>
            <input type="color" [(ngModel)]="configData.background_color" (ngModelChange)="emit()"
              class="input input-sm w-full bg-slate-50 border-slate-200 rounded-xl p-1">
          </div>
          <div class="space-y-1">
            <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Text Color</div>
            <input type="color" [(ngModel)]="configData.text_color" (ngModelChange)="emit()"
              class="input input-sm w-full bg-slate-50 border-slate-200 rounded-xl p-1">
          </div>
        </div>

        <div class="space-y-2">
          <div class="text-[10px] font-black uppercase tracking-widest text-slate-400">Display Style</div>
          <div class="grid grid-cols-2 gap-2">
            @for (style of productShelfStyles; track style.value) {
              <button type="button" (click)="configData.ui_type = style.value; emit()"
                class="p-2.5 rounded-xl border text-center transition-all"
                [ngClass]="configData.ui_type === style.value ? 'border-primary bg-primary/5 ring-2 ring-primary/10 text-primary' : 'border-slate-200 bg-white text-slate-500 hover:border-primary/30'">
                <div
                  class="h-9 mb-2 gap-1"
                  [ngClass]="style.value === 'two_row' ? 'grid grid-rows-2 grid-flow-col place-content-center' : 'flex items-end justify-center'"
                >
                  @for (_ of [1,2,3,4,5,6]; track $index) {
                    <span
                      class="w-4 rounded bg-primary/20 border border-primary/10"
                      [ngClass]="style.value === 'two_row' ? 'h-3' : 'h-5'"
                    ></span>
                  }
                </div>
                <span class="text-[10px] font-black">{{style.label}}</span>
              </button>
            }
          </div>
        </div>

        <div class="space-y-3">
          <div class="text-[10px] font-black uppercase tracking-widest text-slate-400">Data Strategy</div>
          <div class="grid grid-cols-2 gap-2 p-1 bg-slate-100 rounded-xl">
            <button (click)="configData.data_source.type = 'query'; onShelfTypeChange()"
              class="py-2.5 rounded-lg text-[10px] font-black uppercase tracking-tighter transition-all"
              [ngClass]="configData.data_source.type === 'query' ? 'bg-white shadow-sm text-primary' : 'text-slate-400 hover:text-slate-600'">
              <i class="fi fi-rs-search block mx-auto mb-1 text-sm"></i>
              Dynamic Query
            </button>
            <button (click)="configData.data_source.type = 'manual'; onShelfTypeChange()"
              class="py-2.5 rounded-lg text-[10px] font-black uppercase tracking-tighter transition-all"
              [ngClass]="configData.data_source.type === 'manual' ? 'bg-white shadow-sm text-primary' : 'text-slate-400 hover:text-slate-600'">
              <i class="fi fi-rs-list-check block mx-auto mb-1 text-sm"></i>
              Manual Pick
            </button>
          </div>

          @if (configData.data_source.type === 'query') {
            <div class="p-4 bg-slate-50 rounded-xl border border-slate-200 space-y-4">
              <div class="space-y-1">
                <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Category Filter</div>
                <select [(ngModel)]="configData.data_source.query.category_id" (ngModelChange)="emit()"
                  class="select select-xs w-full bg-white border-slate-200 font-bold rounded-lg">
                  <option [ngValue]="undefined">All categories</option>
                  @for (category of flatCategories; track category.id) {
                    <option [ngValue]="'' + category.id">
                      {{getCategoryIndent(category.level)}}{{category.name}}
                    </option>
                  }
                </select>
              </div>

              <div class="space-y-1">
                <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Brand Filter</div>
                <select [(ngModel)]="configData.data_source.query.brand_id" (ngModelChange)="emit()"
                  class="select select-xs w-full bg-white border-slate-200 font-bold rounded-lg">
                  <option [ngValue]="undefined">All brands</option>
                  @for (brand of availableBrands; track brand.id) {
                    <option [ngValue]="'' + brand.id">{{brand.name}}</option>
                  }
                </select>
              </div>

              <div class="flex items-center justify-between">
                <div>
                  <span class="text-xs font-black text-slate-700">Max Products</span>
                  <p class="text-[9px] text-slate-400 font-bold">Cap the number fetched</p>
                </div>
                <input type="number" [(ngModel)]="configData.data_source.query.limit" (ngModelChange)="emit()"
                  class="input input-xs w-16 bg-white border-slate-200 text-center font-black rounded-lg" min="1" max="50">
              </div>
              <div class="flex items-center justify-between">
                <div>
                  <span class="text-xs font-black text-slate-700">Sort Order</span>
                  <p class="text-[9px] text-slate-400 font-bold">How products are ranked</p>
                </div>
                <select [(ngModel)]="configData.data_source.query.sort_by" (ngModelChange)="emit()"
                  class="select select-xs bg-white border-slate-200 font-bold rounded-lg">
                  <option value="featured">⭐ Featured</option>
                  <option value="newest">🆕 Newest First</option>
                  <option value="price_asc">💰 Price: Low→High</option>
                  <option value="price_desc">💎 Price: High→Low</option>
                  <option value="bestseller">🔥 Best Sellers</option>
                  <option value="rating">⭐ Top Rated</option>
                </select>
              </div>
            </div>
          } @else {
            <div class="p-4 bg-slate-50 rounded-xl border border-slate-200 space-y-4">
              <div class="space-y-1">
                <div class="text-[9px] font-black uppercase tracking-widest text-slate-400">Search Products</div>
                <div class="relative">
                  <i class="fi fi-rs-search absolute left-3 top-1/2 -translate-y-1/2 text-slate-300 text-xs"></i>
                  <input type="search" [ngModel]="productSearch" (ngModelChange)="searchProducts($event)"
                    class="input input-sm w-full bg-white border-slate-200 rounded-xl text-xs font-bold pl-8"
                    placeholder="Search product name">
                </div>
              </div>

              @if (manualProducts.length) {
                <div class="space-y-2">
                  <div class="flex items-center justify-between">
                    <span class="text-[9px] font-black uppercase tracking-widest text-slate-400">Selected</span>
                    <span class="text-[9px] font-black text-primary">{{manualProducts.length}} items</span>
                  </div>
                  @for (product of manualProducts; track product.id) {
                    <div class="flex items-center gap-3 p-2.5 bg-white rounded-xl border border-slate-200">
                      <div class="w-10 h-10 rounded-lg bg-slate-50 overflow-hidden border border-slate-100 flex items-center justify-center shrink-0">
                        @if (getPrimaryProductImage(product)) {
                          <img [src]="getPrimaryProductImage(product)" class="w-full h-full object-contain p-1" alt="">
                        } @else {
                          <i class="fi fi-rs-box-open text-slate-300"></i>
                        }
                      </div>
                      <div class="flex-1 min-w-0">
                        <p class="text-xs font-black text-slate-800 truncate">{{product.name}}</p>
                        <p class="text-[9px] text-slate-400 font-bold truncate">{{getPrimaryVariantLabel(product)}} &middot; &#8377;{{getPrimaryVariantPrice(product)}} &middot; Position {{$index + 1}}</p>
                      </div>
                      <div class="flex items-center gap-0.5">
                        <button (click)="moveManualProduct($index, $index - 1)" [disabled]="$index === 0" class="btn btn-ghost btn-xs btn-square text-slate-400 disabled:opacity-20" title="Move up"><i class="fi fi-rs-angle-small-up"></i></button>
                        <button (click)="moveManualProduct($index, $index + 1)" [disabled]="$index === manualProducts.length - 1" class="btn btn-ghost btn-xs btn-square text-slate-400 disabled:opacity-20" title="Move down"><i class="fi fi-rs-angle-small-down"></i></button>
                      </div>
                      <button (click)="removeManualProduct(product.id)"
                        class="btn btn-ghost btn-xs btn-square rounded-lg text-red-400 hover:text-red-600 hover:bg-red-50">
                        <i class="fi fi-rs-trash text-xs"></i>
                      </button>
                    </div>
                  }
                </div>
              }

              <div class="space-y-2">
                <span class="text-[9px] font-black uppercase tracking-widest text-slate-400">Product Library</span>
                @for (product of productResults; track product.id) {
                  <button type="button" (click)="addManualProduct(product)"
                    class="w-full flex items-center gap-3 p-2.5 bg-white rounded-xl border border-slate-200 text-left hover:border-primary/30 hover:bg-primary/5 transition-all disabled:opacity-60"
                    [disabled]="isManualProductSelected(product.id)">
                    <div class="w-10 h-10 rounded-lg bg-slate-50 overflow-hidden border border-slate-100 flex items-center justify-center shrink-0">
                      @if (getPrimaryProductImage(product)) {
                        <img [src]="getPrimaryProductImage(product)" class="w-full h-full object-contain p-1" alt="">
                      } @else {
                        <i class="fi fi-rs-box-open text-slate-300"></i>
                      }
                    </div>
                    <div class="flex-1 min-w-0">
                      <p class="text-xs font-black text-slate-800 truncate">{{product.name}}</p>
                      <p class="text-[9px] text-slate-400 font-bold truncate">{{product.brand?.name || 'No brand'}} &middot; &#8377;{{getPrimaryVariantPrice(product)}}</p>
                    </div>
                    @if (isManualProductSelected(product.id)) {
                      <i class="fi fi-rs-check-circle text-emerald-500 text-sm"></i>
                    } @else {
                      <i class="fi fi-rs-plus-small text-primary text-lg"></i>
                    }
                  </button>
                }

                @if (!productResults.length) {
                  <div class="flex flex-col items-center justify-center p-6 bg-white rounded-xl border border-dashed border-slate-200 text-center opacity-50">
                    <i class="fi fi-rs-search text-2xl text-slate-300 mb-2"></i>
                    <p class="text-[10px] font-black uppercase tracking-widest text-slate-400">No products found</p>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }

  } @else {
    <div class="flex flex-col items-center justify-center h-40 text-center opacity-20">
      <i class="fi fi-rs-mouse-pointer text-4xl mb-4"></i>
      <p class="text-xs font-black uppercase tracking-widest">Select a section to begin</p>
    </div>
  }

</div>
